module.exports = __webpack_public_path__ + "media/images/book-img-04-94821a1b3a185e7d67c34e5232157921.png";